export const tagColorMap: Record<string, string> = {
  CREATED_REQUEST_PLAN: 'blue',
  CREATED_REQUEST_PV: 'blue',
  CREATED_REQUEST_JAM: 'blue',
  CREATED_REQUEST_ADDITIONAL: 'blue',
  DAY_PAYMENT_WIRE: 'purple',
  DAY_PAYMENT_WIRE_DELAY: 'purple',
  DAY_PAYMENT_CARD: 'purple',
  DAY_INVOICE_TAX: 'pink',
  DAY_INVOICE: 'pink',
  NEED_TO_EXTEND: 'rose',
  NON_ISSUE: 'gray',
  COMPLETED_REQUEST: 'gray_dark',
  PLAN: 'blue',
  PV_CHARGE: 'purple',
  JAM_CHARGE: 'pink',
  ADDITIONAL: 'rose',
  wire: 'blue',
  card: 'pink',
  free: 'gray',
  '1': 'blue',
  '2': 'purple',
  '3': 'purple',
  '4': 'pink',
  '6': 'pink',
  '12': 'rose',
  EMAIL: 'blue',
  SYSTEM: 'pink'

}